export default {
  companies: [],
  filters: {},
  paginationOptions: {},
  companyTypes: [],
  companyStatuses: []
};
